import { toast } from 'sonner'

import { FirebaseFields } from 'src/types'

import firestoreService from 'src/api/service'
import localService from 'src/api/localeService'

import {
  AddFuelProps,
  DeleteFuelProps,
  FullFuelTrackingProps,
  UpdateFuelTrackingProps,
} from 'src/api/FuelTracking/types'

export async function addFuelTrackingHistory(
  { carName, payload }: AddFuelProps,
  goToCars: () => void,
): Promise<void> {
  if (!carName) {
    toast(localService.translation.fireBaseErrors.mustHaveCar.mustHave, {
      description: localService.translation.fireBaseErrors.mustHaveCar.suggest,
      action: {
        label: localService.translation.fireBaseErrors.mustHaveCar.okay,
        onClick: goToCars,
      },
    })

    throw Error(localService.translation.fireBaseErrors.mustHaveCar.mustHave)
  }

  await firestoreService.addDataToCollection(
    FirebaseFields.HISTORY_OF_FUEL_TRACK,
    payload,
    carName,
  )
}

export async function getAllFuelTrackingHistory(
  carName?: string,
): Promise<FullFuelTrackingProps[]> {
  if (!carName) {
    throw Error(localService.translation.fireBaseErrors.mustHaveCar.mustHave)
  }

  const fuelTrackHistory =
    await firestoreService.getCollectionData<FullFuelTrackingProps>(
      FirebaseFields.HISTORY_OF_FUEL_TRACK,
      carName,
    )

  return fuelTrackHistory
}

export async function updateFuelTrackingHistory({
  payload,
  id,
  carName,
}: UpdateFuelTrackingProps): Promise<void> {
  await firestoreService.updateDataInCollection(
    FirebaseFields.HISTORY_OF_FUEL_TRACK,
    id,
    payload,
    carName,
  )
}

export async function deleteFuelTrackingHistoryItem({
  carName,
  id,
}: DeleteFuelProps): Promise<void> {
  await firestoreService.deleteDataFromCollection(
    FirebaseFields.HISTORY_OF_FUEL_TRACK,
    id,
    carName,
  )
}

export async function getItemById(
  id: string,
): Promise<FullFuelTrackingProps | null> {
  return firestoreService.getItemById<FullFuelTrackingProps>(
    FirebaseFields.HISTORY_OF_FUEL_TRACK,
    id,
  )
}
